"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgendaSlotsHttpService = void 0;
const agenda_slot_set_accounting_information_1 = require("../../types/agenda-slots/agenda-slot-set-accounting-information");
const book_agenda_slot_1 = require("../../types/agenda-slots/book-agenda-slot");
const create_slot_1 = require("../../types/agenda-slots/create-slot");
const create_slot_bulk_1 = require("../../types/agenda-slots/create-slot-bulk");
const delete_agenda_slot_1 = require("../../types/agenda-slots/delete-agenda-slot");
const delete_agenda_slot_occurence_1 = require("../../types/agenda-slots/delete-agenda-slot-occurence");
const get_agenda_slot_available_list_1 = require("../../types/agenda-slots/get-agenda-slot-available-list");
const get_agenda_slot_booked_stats_list_1 = require("../../types/agenda-slots/get-agenda-slot-booked-stats-list");
const get_agenda_slot_by_id_1 = require("../../types/agenda-slots/get-agenda-slot-by-id");
const get_agenda_slot_list_1 = require("../../types/agenda-slots/get-agenda-slot-list");
const get_move_slot_options_1 = require("../../types/agenda-slots/get-move-slot-options");
const get_slot_assistant_day_boundary_1 = require("../../types/agenda-slots/get-slot-assistant-day-boundary");
const get_substitute_earnings_stats_1 = require("../../types/agenda-slots/get-substitute-earnings-stats");
const move_agenda_slot_1 = require("../../types/agenda-slots/move-agenda-slot");
const stop_recurrence_1 = require("../../types/agenda-slots/stop-recurrence");
const update_agenda_slot_assistant_mode_1 = require("../../types/agenda-slots/update-agenda-slot-assistant-mode");
const http_service_1 = require("../http.service");
class AgendaSlotsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/agenda-slots`);
    }
    getList(payload) {
        const params = {
            ...payload,
            from: payload.from.toISOString(),
            to: payload.to.toISOString(),
        };
        return this.getEntityList('', {
            params,
            schema: get_agenda_slot_list_1.getAgendaSlotsListApiResponseSchema,
        });
    }
    getById(id) {
        return this.getEntity(id, {
            schema: get_agenda_slot_by_id_1.getAgendaSlotByIdResponseSchema,
        });
    }
    getPaginateList(payload) {
        const params = {
            ...payload,
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.from) {
            params.from = payload.from.toISOString();
        }
        if (payload.to) {
            params.to = payload.to.toISOString();
        }
        return this.getEntityList('paginate', {
            params,
            schema: get_agenda_slot_list_1.getAgendaSlotsListApiResponseSchema,
        });
    }
    getAvailableList(payload) {
        const params = {
            ...payload,
            from: payload.from.toISOString(),
            to: payload.to.toISOString(),
        };
        return this.getEntityList('available-list', {
            params,
            schema: get_agenda_slot_available_list_1.getAgendaSlotsAvailableListApiResponseSchema,
        });
    }
    create(payload) {
        return this.postEntity('', {
            body: payload,
            schema: create_slot_1.createAgendaSlotApiResponseSchema,
        });
    }
    createBulk(payload) {
        return this.postEntityList('bulk', {
            body: payload,
            schema: create_slot_bulk_1.createAgendaSlotBulkApiResponseSchema,
        });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_agenda_slot_1.deleteAgendaSlotApiResponseSchema,
        });
    }
    deleteOccurrence(id, payload) {
        return this.postEntity(`${id}/delete-occurence`, {
            body: payload,
            schema: delete_agenda_slot_occurence_1.deleteOccurrenceAgendaSlotApiResponseSchema,
        });
    }
    stopRecurrence(id, payload) {
        return this.postEntity(`${id}/stop-recurrence`, {
            body: payload,
            schema: stop_recurrence_1.stopRecurrenceAgendaSlotApiResponseSchema,
        });
    }
    updateAssistantMode(id, payload) {
        return this.put(`${id}/assistant-mode`, {
            body: payload,
            schema: update_agenda_slot_assistant_mode_1.updateAgendaSlotAssistantModeApiResponseSchema,
        });
    }
    bookById(id, payload) {
        return this.postEntity(`${id}/book`, {
            body: payload,
            schema: book_agenda_slot_1.bookAgendaSlotApiResponseSchema,
        });
    }
    getBookedStats(payload) {
        const params = {
            officeId: payload.officeId,
            from: payload.from.toISOString(),
            to: payload.to.toISOString(),
            timezone: payload.timezone,
        };
        return this.getEntityList('booked-stats', {
            params,
            schema: get_agenda_slot_booked_stats_list_1.getAgendaSlotsBookedStatsListApiResponseSchema,
        });
    }
    importDoctolibCsv(id, payload) {
        return this.post(`${id}/import-doctolib-csv`, {
            body: payload,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    exportDoctolibCsv(id) {
        const url = this.getApiUrlOf(`${id}/export-doctolib-csv`);
        return this.fetch(url, {
            method: 'GET',
            transformTo: 'blob',
        });
    }
    setAccountingInformation(id) {
        return this.post(`${id}/set-accounting-information`, {
            schema: agenda_slot_set_accounting_information_1.agendaSlotSetAccountingInformationApiResponseSchema,
        });
    }
    getMoveOptions(id, payload) {
        return this.get(`${id}/move-options`, {
            params: payload,
            schema: get_move_slot_options_1.getMoveSlotOptionsResponseSchema,
        });
    }
    moveSlot(id, payload) {
        return this.post(`${id}/move`, {
            body: payload,
            schema: move_agenda_slot_1.moveAgendaSlotResponseSchema,
        });
    }
    getAssistantDayBoundary(payload) {
        return this.get('assistant-day-boundary', {
            params: { periodOfTheDay: payload.periodOfTheDay },
            schema: get_slot_assistant_day_boundary_1.getSlotAssistantDayBoundaryResponseSchema,
        });
    }
    getSubstituteEarningsStats(payload) {
        const params = {
            from: payload.from.toISOString(),
            to: payload.to.toISOString(),
        };
        return this.getEntityList('substitute-earnings-stats', {
            params,
            schema: get_substitute_earnings_stats_1.getSubstituteEarningsStatsApiResponseSchema,
        });
    }
}
exports.AgendaSlotsHttpService = AgendaSlotsHttpService;
